module.exports = __webpack_public_path__ + "img/Tessellate26.70ab47d2.jpg";